import Cookies from "js-cookie";
import { CmpConsentDecisionToDomain } from "@/vue/services/cmp/CmpModel";
import md5 from "md5";

export const blockConsentTransferCookieBaseName = "block_consent_transfer_";

export function transferConsentToCurrentDomain(
  customerId: string,
  controllerId: string,
  consents: CmpConsentDecisionToDomain[],
  customerConsentToken?: string,
  forceTransfer?: boolean
) {
  const preventMultipleTransfersCookieName =
    blockConsentTransferCookieBaseName + md5(customerId);
  if (
    forceTransfer ||
    Cookies.get(preventMultipleTransfersCookieName) !== controllerId
  ) {
    let restEndpointUrl = `/rest/cmpCustomerConsents/${customerId}`;
    if (customerConsentToken) {
      restEndpointUrl = `${restEndpointUrl}?token=${customerConsentToken}`;
    }

    fetch(restEndpointUrl, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({
        cmpConsentId: controllerId,
        cmpConsents: consents
      })
    })
      .then(response => {
        if (response && response.ok) {
          Cookies.set(preventMultipleTransfersCookieName, controllerId, {
            secure: true,
            sameSite: "strict",
            expires: 2 //two days from now REST call will be repeated for fault tolerance
          });
        } else if (response && response.status === 409) {
          window.cmpService.enforceNewConsentDecision();
        }
      })
      .catch(error => {
        if (error != null) {
          console.error(
            `Could not perform consent PUT: ${JSON.stringify(
              error,
              Object.getOwnPropertyNames(error)
            )}`
          );
        } else {
          console.error(`Could not perform consent PUT. Error was null.`);
        }
      });
  }
}

export function enforceTransferOnNextOccasionThroughCookieDeletion(
  ucControllerId: string
) {
  const allCookies = Cookies.get();
  const cookieNames = Object.keys(allCookies);
  cookieNames.forEach(cookieName => {
    if (
      cookieName.includes(blockConsentTransferCookieBaseName) &&
      allCookies[cookieName] === ucControllerId
    ) {
      Cookies.remove(cookieName);
    }
  });
}
